import { RootState } from '../store';

import { IStationsListState } from './stations-list.slice';

export const selectStations = (state: RootState): IStationsListState => state.stations;

export const selectStationsParamsSearch = (state: RootState): string =>
    state.stationsListParams.search;
